import { useWhoamiControllerGetWhoamiSuspense } from "@/api/orval/connect";

/**
 * リクエストしているユーザー自身のロールと所属テナント。
 *
 * ロールの正はサーバが返す値。クライアント側で推測しない。
 * ホストは全テナントを横断でき、クレジットとユーザー数上限の対象外。
 */
export const useGetWhoami = () => {
  const { data } = useWhoamiControllerGetWhoamiSuspense();

  return {
    role: data.role,
    tenantId: data.tenantId,
    tenantName: data.tenantName,
    email: data.email,
    name: data.name,
    isHost: data.role === "host",
  };
};
